module.exports = __webpack_public_path__ + "img/trunk_4x1_z18.6ee52caf.svg";